export const GANTT_CHART_STEPS_PER_HOUR = 1 as const
export const SLIDER_ROUND_TO_INTERVAL_HOURS = 12
